import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useLogin } from "../../../../context/LoginContext";
import localStorageKey from "../../../../enumerations/localStorageKey";
import { useGetFacebookLink } from "../../../../hooks/facebookLink/facebookLink.hooks";
import { useGetTGBetChannelLink } from "../../../../hooks/tgBetChannelLink/tglink.hooks";
import { useGetTGChannelLink } from "../../../../hooks/tgChannelLink/tglink.hooks";
import { useGetTGLink } from "../../../../hooks/tgLink/tglink.hooks";
import { useGetWhatsappLink } from "../../../../hooks/whatsappLink/whatsappLink.hooks";
import {
  safeOpenChatwootWidget,
  safeToggleChatwootBubble,
} from "../../../../plugins/safeChatwootBubble";
import { envChangeType } from "../../../../plugins/utils";
import CsIcon from "./images/cs.png";
import ExpandIcon from "./images/ExpandIcon";
import FbIcon from "./images/facebook.png";
import TgIcon from "./images/telegram.png";
import TgBetChannelIcon from "./images/tgBet.png";
import TgChannelIcon from "./images/tgChannel.png";
import WhatsappIcon from "./images/whatsapp.png";
import styles from "./style.module.scss";

const RightFloatingButton = () => {
  const { t } = useTranslation();
  const { openCSDrawer } = useLogin();
  const location = useLocation();
  const currency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);
  const [isExpand, setIsExpand] = useState(false);
  const [isChatwootReady, setIsChatwootReady] = useState(false);

  useEffect(() => {
    const syncChatwootReady = () => {
      safeToggleChatwootBubble("hide");
      setIsChatwootReady(window.$chatwoot?.hasLoaded === true);
    };

    syncChatwootReady();
    window.addEventListener("chatwoot:ready", syncChatwootReady);
    return () => window.removeEventListener("chatwoot:ready", syncChatwootReady);
  }, [location.pathname]);

  const { data: tgLink } = useGetTGLink({
    options: { enabled: !!currency },
  });
  const { data: tgChannelLink } = useGetTGChannelLink({
    options: { enabled: !!currency },
  });
  const { data: tgBetChannelLink } = useGetTGBetChannelLink({
    options: { enabled: !!currency },
  });
  const { data: facebookLink } = useGetFacebookLink({
    options: { enabled: !!currency },
  });
  const { data: whatsappLink } = useGetWhatsappLink({
    options: { enabled: !!currency },
  });

  const FLOATING_ITEMS = [
    {
      key: "24cs",
      label: t("normal.24cs"),
      icon: <img src={CsIcon} alt="cs" width={24} />,
      onClick: () => {
        openCSDrawer();
      },
      show: !envChangeType("REACT_APP_CHATWOOT_URL"),
    },
    {
      key: "chatwoot",
      label: t("normal.24cs"),
      icon: <img src={CsIcon} alt="cs" width={22} />,
      onClick: () => {
        safeOpenChatwootWidget();
      },
      show: isChatwootReady && !!envChangeType("REACT_APP_CHATWOOT_URL"),
    },
    {
      key: "telegram",
      label: t("normal.tg"),
      icon: <img src={TgIcon} alt="tg" width={22} />,
      onClick: () => {
        if (!tgLink || !tgLink.data) return;
        window.open(tgLink?.data);
      },
      show: tgLink && tgLink.data && tgLink?.data !== "",
    },
    {
      key: "facebook",
      label: t("normal.facebook"),
      icon: <img src={FbIcon} alt="facebook" width={22} />,
      onClick: () => {
        if (!facebookLink || !facebookLink.data) return;
        window.open(facebookLink?.data);
      },
      show: facebookLink && facebookLink.data && facebookLink?.data !== "",
    },
    {
      key: "whatsapp",
      label: t("normal.whatsapp"),
      icon: <img src={WhatsappIcon} alt="whatsapp" width={22} />,
      onClick: () => {
        if (!whatsappLink || !whatsappLink.data) return;
        window.open(whatsappLink?.data);
      },
      show: whatsappLink && whatsappLink.data && whatsappLink?.data !== "",
    },
    {
      key: "tgChannel",
      label: t("normal.tgChannel"),
      icon: <img src={TgChannelIcon} alt="tgChannel" width={22} />,
      onClick: () => {
        if (!tgChannelLink || !tgChannelLink.data) return;
        window.open(tgChannelLink?.data);
      },
      show: tgChannelLink && tgChannelLink.data && tgChannelLink?.data !== "",
    },
    {
      key: "tgBetChannel",
      label: t("normal.tgBetChannel"),
      icon: <img src={TgBetChannelIcon} alt="tgBetChannel" width={22} />,
      onClick: () => {
        if (!tgBetChannelLink || !tgBetChannelLink.data) return;
        window.open(tgBetChannelLink?.data);
      },
      show: tgBetChannelLink && tgBetChannelLink.data && tgBetChannelLink?.data !== "",
    },
  ];

  const visibleItems = FLOATING_ITEMS.filter((item) => item.show);

  return visibleItems.length > 0 ? (
    <div className={styles.rightFloatingButton}>
      {visibleItems.map((item, index) => {
        const button = (
          <button type="button" className={styles.floatingItem} onClick={item.onClick}>
            <span className={styles.iconWrap}>{item.icon}</span>
            <span className={styles.label}>{item.label}</span>
          </button>
        );

        if (index === 0) {
          return (
            <div key={item.key} className={styles.floatingItemWrap}>
              {button}
            </div>
          );
        }

        return (
          <div
            key={item.key}
            className={`${styles.extraItem} ${isExpand ? styles.extraItemVisible : ""}`}
          >
            <div className={styles.extraItemInner}>{button}</div>
          </div>
        );
      })}
      {visibleItems.length > 1 && (
        <div
          className={`${styles.expandIcon} ${isExpand === true ? styles.expanded : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            setIsExpand((prevState) => !prevState);
          }}
        >
          <ExpandIcon style={{ fontSize: 20 }} />
        </div>
      )}
    </div>
  ) : null;
};

export default RightFloatingButton;
